// extracted by mini-css-extract-plugin
export default {"link":"LegalModal_link__mL99n"};